/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Material Dashboard 2 React Base Styles
import colors from 'assets/theme-dark/base/colors';
import typography from 'assets/theme-dark/base/typography';

// Material Dashboard 2 React helper functions
import pxToRem from 'assets/theme-dark/functions/pxToRem';
import rgba from 'assets/theme-dark/functions/rgba';

const { inputBorderColor, info, grey, text } = colors;
const { size } = typography;

const inputFilled = {
  styleOverrides: {
    root: {
      color: text.main,

      '&:before': {
        borderColor: rgba(inputBorderColor, 0.6)
      },

      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `1px solid ${inputBorderColor}`
      },

      '&.Mui-focused': {
        '& .MuiFilledInput-underline': {
          borderColor: info.main
        }
      },
      '& .MuiInputAdornment-root .MuiSvgIcon-root': {
        color: rgba(text.main, 0.7)
      }
    },

    inputSizeSmall: {
      fontSize: size.xs,
      padding: pxToRem(10)
    },

    multiline: {
      color: grey[300]
    }
  }
};

export default inputFilled;
